module.exports = __webpack_public_path__ + "static/media/sv-SE.0281daf4.md";